module.exports = __webpack_public_path__ + "static/team_yohan-a99bb0c7ac631b0b12b3620323825608.jpg";